import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** The column definition for the member's companies table with the field property typed */
export type CompaniesTableGridColDef = DataGridCellParams<
  FaroCoreApiTypes.AdmUserCompany,
  CompaniesTableColumnField
>;

/** The column fields that can be used in the member's companies table */
export type CompaniesTableColumnField =
  "name" | "role" | "numberOfMembers" | "numberOfProjects" | "type" | "options";

/** The labels for the columns in the member's companies table */
export const COMPANIES_TABLE_COLUMN_LABELS: Record<
  CompaniesTableColumnField,
  string
> = {
  name: "Workspace Name",
  role: "Role",
  numberOfMembers: "Number of Members",
  numberOfProjects: "Number of Projects",
  type: "Type",
  options: "",
};
